module.exports = __webpack_public_path__ + "static/KeepSmallStrong-hero-e46b9407bb9f540cd085c16f46424505.jpg";